import React from 'react';
import style from './previousModificationRequests.module.scss';
import { BookingModificationRequest } from 'acscp/api/models/bookingModificationRequest';
import { FormattedMessage } from 'react-intl';
import { ArrowIcon } from '../common/icons/arrowIcon';

interface PreviousModificationRequestsProps {
    modificationRequests: BookingModificationRequest[];
}
interface PreviousModificationRequestsState {
    showRequests: boolean;
}

export class PreviousModificationRequests extends React.Component<PreviousModificationRequestsProps, PreviousModificationRequestsState> {
    constructor(props: PreviousModificationRequestsProps) {
        super(props);
        this.state = { showRequests: true };
    }

    toggleRequests = () => {
        if (this.props.modificationRequests.length > 0) {
            const showRequests = !this.state.showRequests;
            this.setState({ showRequests });
        }
    }

    render(): JSX.Element {
        return (
            <div className={style.previousModificationRequestsContainer}>
                <div className={style.previousModificationRequestsTopBar}>
                    <FormattedMessage
                        id={'web.components.booking.previousModificationRequests.title'}
                        defaultMessage={'PREVIOUSLY REQUESTED CHANGES'}
                    />
                    <button
                        onClick={() => this.toggleRequests()}
                        className={this.state.showRequests ? style.buttonHide : style.buttonShow}
                    >
                        {this.state.showRequests
                            ? <FormattedMessage id={'web.components.booking.previousModificationRequests.hide'} defaultMessage={'HIDE'} />
                            : <FormattedMessage id={'web.components.booking.previousModificationRequests.show'} defaultMessage={'SHOW'} />
                        }
                        <ArrowIcon />
                    </button>
                </div>
                {this.state.showRequests && <ul className={style.previousModificationRequestsList}>
                    {this.props.modificationRequests.map((request, index) =>
                        <li key={index} className={style.PreviousModificationRequest}>
                            <div className={style.PreviousModificationRequestHeader}>
                                <div className={style.PreviousModificationRequestDate}>
                                    {request.dateSubmitted}
                                </div>
                                <div className={style.PreviousModificationRequestUser}>
                                    {request.user}
                                </div>
                            </div>
                            <div>
                                {request.modificationRequest}
                            </div>
                        </li>
                    )}
                </ul>}
            </div>
        );
    }
}
